<div class="container px-0" *ngIf="!selectedApp">
  <section>
    <ul
      ngbNav
      #nav="ngbNav"
      [(activeId)]="active"
      class="nav-tabs nav-justified sticky-top bg-white"
    >
      <li [ngbNavItem]="1">
        <a ngbNavLink>{{ "RESOURCES" | translate }}</a>
        <ng-template ngbNavContent>
          <section>
            <div class="row justify-content-center my-4 py-3 searchbar">
              <ng-template
                [ngTemplateOutlet]="search"
                [ngTemplateOutletContext]="{
                  placeholder: 'Search Resources'
                }"
              >
              </ng-template>
            </div>
            <div *ngFor="let app of services">
              <div class="row" *ngIf="app.type == 'risorsa'">
                <div class="col-12 px-0">
                  <div class="row cursor-pointer" (click)="selectApp(app)">
                    <div class="col-2">
                      <!-- Logo dell'applicazione -->
                      <div
                        class="application text-center d-flex flex-column justify-content-center"
                      >
                        <div
                          class="application-logo m-3"
                          style="background-image: url({{ app.icon }});"
                        ></div>
                      </div>
                    </div>
                    <div
                      class="col-10 d-flex flex-column justify-content-center"
                    >
                      <!-- Nome della categoria -->
                      <div class="category">
                        {{ app.name }}
                      </div>
                      <!-- Nome dell'applicazione -->
                      <div class="application-name">
                        {{ app.label }}
                      </div>
                      <!-- Descrizione dell'applicazione -->
                      <div class="app-description pe-5">
                        {{ app.description }}
                      </div>
                    </div>
                    <!-- Linea separatoria -->
                    <hr class="w-100 my-2" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink>{{ "ACTIVATIONS" | translate }}</a>
        <ng-template ngbNavContent>
          <section>
            <div class="row justify-content-center my-4 py-3 searchbar">
              <ng-template
                [ngTemplateOutlet]="search"
                [ngTemplateOutletContext]="{
                  placeholder: 'Search Activations'
                }"
              >
              </ng-template>
            </div>
            <div *ngFor="let app of services">
              <div class="row" *ngIf="app.type == 'attivazione'">
                <div class="col-12 px-0">
                  <div class="row cursor-pointer" (click)="selectApp(app)">
                    <div class="col-2">
                      <!-- Logo dell'applicazione -->
                      <div
                        class="application text-center d-flex flex-column justify-content-center"
                      >
                        <div
                          class="application-logo m-3"
                          style="background-image: url({{ app.icon }});"
                        ></div>
                      </div>
                    </div>
                    <div
                      class="col-10 d-flex flex-column justify-content-center"
                    >
                      <!-- Nome della categoria -->
                      <div class="category">
                        {{ app.name }}
                      </div>
                      <!-- Nome dell'applicazione -->
                      <div class="application-name">
                        {{ app.label }}
                      </div>
                      <!-- Descrizione dell'applicazione -->
                      <div class="app-description pe-5">
                        {{ app.description }}
                      </div>
                    </div>
                    <!-- Linea separatoria -->
                    <hr class="w-100 my-2" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </section>
</div>
<div class="container p-4" *ngIf="selectedApp">
  <div class="row d-flex justify-content-center">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closeModal()"
    ></button>
    <div class="col-12 text-center modal-title mb-2">
      {{ "SUBMIT_REQUEST" | translate }}
    </div>
    <div class="new-req-form">
      <div class="row">
        <app-dynamic-form
          [formName]="'stagingForm'"
          [formData]="formData!"
          [form]="formData!"
          [disabled]="false"
          [submitButton]="'SUBMIT' | translate"
          (formSubmit)="confirmNewRequest($event)"
          (formValidation)="emitFormValidation($event)"
          (formChange)="onFormEventChange()"
          [customFunctions]="customFunctions"
          [subFormsValidationStatus]="subFormsValidationStatus"
          #dynamicForm
        >
        </app-dynamic-form>
      </div>
    </div>
  </div>
</div>
<ng-template #rt let-r="result" let-t="term">
  <img [src]="r.icon" class="me-1" style="width: 16px" alt="service icon" />
  <ngb-highlight class="m-3" [result]="r.name" [term]="t"></ngb-highlight>
</ng-template>
<ng-template #search let-placeholder="placeholder">
  <div class="col-6 position-relative">
    <input
      type="text"
      class="form-control ps-3 pe-5 rounded-pill"
      placeholder="{{ placeholder }}"
      [(ngModel)]="textSearch"
      (keyup)="applySearchFilter()"
    />
    <div class="position-absolute top-50 translate-middle-y searchicon">
      <fa-icon [icon]="faSearch"></fa-icon>
    </div>
  </div>
</ng-template>
